import React from 'react';
import QRCode from 'qrcode.react';
import { Label, FormGroup } from 'reactstrap';
import { FMessage } from '../../hoc/IntlComponents';

const FlowQRCode = ({ link }) => (
  <div className="flow-qr-code">
    <QRCode value={link} />
    <Label>
      <FMessage id="flow.form.qr-code" />
    </Label>
  </div>
);

export default FlowQRCode;
